import _ from 'lodash';
export const headerTyps = [
    { id: 'sales', name: '매출액' },
    { id: 'purchase', name: '매입액' },
    { id: 'profitPrice', name: '매출이익' },
    { id: 'profit', name: '이익률' },
];

export const prjImpts = [
    { id: 'd11d0cd7-9e7a-4e4d-a639-bb35de919b47', name: 'High(90%이상)', val: 'High' },
    { id: '36069e98-2c11-4ee8-8369-6c9847cc201d', name: 'Medium(50%초과~90%미만)', val: 'Medium' },
    { id: '25edb655-b0b4-4fbf-9094-1f779baf38b4', name: 'Low(50%이하)', val: 'Low' },
    { id: 'total', name: '전체', val: 'total' }
]

export const teamData = [
    {
        id: '1', name: '인프라영업본부', rowSpan: 4, children: [
            { id: '1-1', name: '고객영업1팀' },
            { id: '1-2', name: '고객영업2팀' },
            { id: '1-3', name: '고객영업3팀' },
            { id: '1-4', name: '고객영업4팀' },
        ]
    },
    {
        id: '2', name: '채널영업본부', rowSpan: 1, children: [
            { id: '2-1', name: '채널영업팀' },

        ]
    },
    {
        id: '3', name: 'NI영업본부', rowSpan: 1, children: [
            { id: '2-1', name: 'NI영업팀' },
        ]
    },
    {
        id: 'total', name: '합계', rowSpan: 1, children: [
            { id: 'total', name: '합계' },
        ]
    },
]


export const makeDataForecastMonth = () => {
    teamData.map((hq) => {
        return hq.children.map((team) => {
            return prjImpts.map((imp) => {
                let priceData = {
                    sales: `${Math.floor(Math.random() * 1000000000)}`,
                    purchase: `${Math.floor(Math.random() * 1000000000)}`,
                    profit: `${_.random(1, 200)} %`
                }
                team[imp.val] = priceData;
            })
        })
    })
    return Array.from(teamData);
}